import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Sortable from 'react-sortablejs'

class Ladder extends Component {

	constructor(props) {
		super(props)
		this.state = { }
		this.computeLiveRank = this.computeLiveRank.bind(this)
	}

	computeLiveRank(teamid) {
		for (let i = 0; i < this.props.order.length; i++) {
			if (Number(this.props.order[i]) === Number(teamid)) {
				return i
			}
		}
		return null
	}

	render() {

		const { teams, standings, order, officialOrder, onMove, year } = this.props

		if (!officialOrder || !order) {
			return (
				<p className="loading-text">
					LOADING
				</p>
			)
		}

		return (
			<div id="lscore-ladder">
				<div id="col-ranks">
					{
						order.map( (id, idx)  => (
							<LadderRowNumber rank={idx+1} key={id} year={year} />
						))
					}
				</div>

				<Sortable
					onChange={(newOrder, sortable, event) => onMove({
						newOrder,
						event
					})}
					options={{
						animation: 150,
						onMove: event => onMove({
							event,
						}),
					}}
				>
					{
						officialOrder.map( (id, idx)  => (
							<LadderRow
								t={teams[id]} key={id} idx={idx} liverank={this.computeLiveRank(id)} year={year}
							/>
						))
					}
				</Sortable>

				<div id="col-markers">
					{
						(standings && standings.length) ?
							order.map( (id, idx)  => (
								<LadderRowRankError t={teams[id]} rank={idx+1} key={id} />
							)) : null
					}
				</div>
			</div>
		)
	}
}


Ladder.propTypes = {
	teams: PropTypes.object,
	standings: PropTypes.array,
}

class LadderRow extends Component {
	render() {

		const { t, idx, liverank, year } = this.props
		const finalistsN = year >= 2026 ? 10 : 8

		const c = 'teamname ' + t.abbrev + ' ' + (liverank < finalistsN ? 'finalists' : '')

		return (
			<div className="magnet" key={t.abbrev} data-idx={idx} data-id={t.id} data-liverank={this.props.liverank}>
			<div className="lscore-ladder-row">
					<div><img src={t.logo} alt="" className="ladderteamlogo" /></div>
					<div className={c}>{t.name}</div>
				</div>
			</div>
		)
	}
}

class LadderRowNumber extends Component {
	render() {

		const { rank, year } = this.props
		const finalistsN = year >= 2026 ? 10 : 8

		const c = rank <= finalistsN ? 'finalists' : ''

		return (
			<div className="rank-container">
				<div className={c}>
					{rank}
				</div>
			</div>
		)
	}
}

class LadderRowRankError extends Component {
	render() {
		const { t, rank } = this.props

		const diff = rank - t.rank
		const absDiff = Math.abs(diff)
		const diffClass = (diff ? (diff < 0 ? 'negDiff' : 'posDiff') : 'ok')
		const diffStr = absDiff || '✓'

		return (
			<div className="rankError">
				<span className={diffClass}>{diffStr}</span>
			</div>
		)
	}
}

LadderRow.propTypes = {
	t: PropTypes.object,
}

export default Ladder
